import { ErrorMessage } from 'formik';
import React, { Component } from 'react';
import Input from '../../components/Input/input.component';
import WidgetModalForm, { ModalFormContext } from '../../components/Modal/modalForm.component';
import Required from '../../components/Required/required.component';
import CheckboxGroup from '../../components/Checkbox/checkboxGroup.component';
import { EditarItemDacaSchema } from './editarItemDaca.modal.validate';

export default class EditarModal extends Component {
	handleChangeCheckboxGroup(values) {
		const {
			daca,

		} = this.props;

		for (let index = 0; index < values.length; index++) {
			if (daca.tiposExibicao.indexOf(values[index]) > -1) {
				daca.tiposExibicao.concat(values[index]);
			}
		}
	}

	render() {
		const {
			props: {
				handleSubmitEditar,
				handleCloseEditar,
				isOpenEditar,
				daca,
			},
		} = this;
		return (
			<WidgetModalForm
				textCancelar='Cancelar'
				textConfirmar='Salvar'
				title='Editar item'
				confirmar={handleSubmitEditar}
				isOpen={isOpenEditar}
				cancelar={handleCloseEditar}
				initialValues={daca}
				modalConfirmarFechar
				modalConfirmarCancelar
				modalConfirmarCancelarTitulo='Atenção!'
				modalConfirmarCancelarCorpo='Tem certeza que deseja cancelar? Todos os dados preenchidos serão perdidos.'
				iconCancelar='fas fa-times'
				iconConfirmar='fas fa-save'
				tamanho='lg'
				validationSchema={EditarItemDacaSchema}
			>
				<ModalFormContext.Consumer>
					{({
						values, handleChange, setFieldValue,
					}) => (
						<div>
							<div className='row'>
								<div className='col-md-12'>
									<label>
										<strong>Código: </strong>{daca.id}
									</label>
								</div>
							</div>
							<div className='row'>
								<div className='col-md-12'>
									<label>
											Nome do item:
											{' '}
										<Required />
									</label>
									<div className='form-group'>
										<Input
											type='input'
											name='nome'
											onChange={handleChange}
											value={values.nome}
											maxLength='255'
										/>
									</div>
									<ErrorMessage
										name='nome'
										render={msg => (
											<div className='mb-1'>
												<span className='text-danger'>
													{' '}
													{msg}
												</span>

											</div>
										)}
									/>
								</div>
							</div>
							<div className='row'>
								<div className='col-md-12'>
									<label>
											Descrição do item:
											{' '}
										<Required />
									</label>
									<div className='form-group'>
										<Input
											type='textarea'
											name='descricao'
											onChange={handleChange}
											value={values.descricao}
											rows='3'
											maxLength='255'
										/>
									</div>
									<ErrorMessage
										name='descricao'
										render={msg => (
											<div className='mb-1'>
												<span className='text-danger'>
													{' '}
													{msg}
												</span>

											</div>
										)}
									/>
								</div>
							</div>

							<div className='row'>
								<div className='col-lg-12 col-sm-12'>
									<label>
											O item é material permanente ou bens de consumo?
											{' '}
										<Required />
									</label>
									<div className='col-12 ml-1 form-check'>
										<div className='radio'>
											<label>
												<Input
													disabled
													id='radio_1'
													value={values.permanente}
													checked={values.permanente}
													name='permanente'
													type='radio'
													bsSize='sm'
													className='form-check-input'
													onChange={() => setFieldValue('permanente', true)}
												/>
												<span className='pointer-text form-check-label'>Material permanente</span>
											</label>
										</div>
										<div className='radio'>
											<label>
												<Input
													disabled
													id='radio_2'
													value={values.permanente}
													checked={!values.permanente}
													name='permanente'
													type='radio'
													className='form-check-input'
													bsSize='sm'
													onChange={() => setFieldValue('permanente', false)}
												/>
												<span className='pointer-text form-check-label'>Bens de consumo</span>
											</label>
										</div>
									</div>
									<ErrorMessage
										name='permanente'
										render={msg => (
											<div className='mb-1'>
												<span className='text-danger'>
													{' '}
													{msg}
												</span>

											</div>
										)}
									/>
								</div>
							</div>

							<div className='row'>
								<div className='col-lg-12 col-sm-12'>
									<label>
											Local de exibição:
											{' '}
										<Required />
									</label>
									<div className='row col-md-12'>
										<CheckboxGroup
											styleInput
											key='tiposExibicao'
											id='tiposExibicao'
											name='tiposExibicao'
											isVerificaValores
											value={
												values.tiposExibicao || []
											}
											values={[
												{
													id: 1,
													nome: 'PDR',
												},
												{
													id: 2,
													nome: 'PDP',
												},
												{
													id: 3,
													nome: 'Não exibir',
												},
											]}
											setFieldValue={setFieldValue}
											handleChangeCheckboxGroup={value => this.handleChangeCheckboxGroup(
												value,
											)
											}
										/>
									</div>
									<ErrorMessage
										name='tiposExibicao'
										render={msg => (
											<div className='mb-1'>
												<span className='text-danger'>
													{' '}
													{msg}
												</span>

											</div>
										)}
									/>
								</div>
							</div>
						</div>
					)}
				</ModalFormContext.Consumer>
			</WidgetModalForm>
		);
	}
}
